export const isNullType = (x) =>
  x == null || x === '' || /(NoInformation|(Not(Collected|Disclosed|Applicable|Meaningful)))/i.test(x);
